import React, { useState } from "react";
// import IP from "../../../images/IP.png"
// import TajMahal from "../../../images/TajMahal.png"
import IP from "../../../images/peck2.jpg";
import "./ForgetPassword.css";
import { useNavigate } from "react-router-dom";
import { postRequestGlobal } from "../../../API/global";
import ForgetPasswordDetails from "../PartialsView/ForgetPasswordDetails";
import VerifyOtpVerification from "../PartialsView/VerifyOtpVerification";
import ChangedPasswordDetails from "../PartialsView/ChangedPasswordDetails";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import pecock_vdo from "../../../images/peco.gif";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const ForgetPassword = () => {
  const [showForgetPasswordForm, setShowForgetPasswordForm] = useState(true);
  const [showOtpForm, setShowOtpForm] = useState(true);
  const [loading, setLoading] = useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const [email, setEmail] = useState(""); // New state for email

  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  // const [otpValue, setOtpValue] = useState(null);
  const [otpValue, setOtpValue] = useState("");

  const [formData, setFormData] = useState({ email: "" });
  // console.log("Email in formData:", formData.email);

  // const [formData, setFormData] = useState("");
  const [otpVerification, setOtpVerification] = useState({
    email: "",
    otp: "",
  });
  const [changedPassword, setChangedPassword] = useState({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const [errors, setErrors] = useState({});

  const validateValues = (inputValues) => {
    const errors = {};

    // Basic email format regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!inputValues.email) {
      errors.email = "Email ID is required";
    } else if (!emailRegex.test(inputValues.email)) {
      errors.email = "Invalid Email ID format";
    }

    return errors;
  };

  const validatePassword = async (password) => {
    const regex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/g;
    let data = regex.test(password);
    if (data) {
      setPasswordError("");
      return true;
    } else {
      setPasswordError(
        "Password must be at least 8 characters long and include at least 1 alphabet, 1 number, and 1 special character."
      );
      return false;
    }
  };

  const validatePasswordValues = (inputValues) => {
    const { password, password_confirmation } = inputValues;
    let errors = {};
    if (password.length < 8) errors.password = "Password is too short";
    if (password_confirmation.length < 8)
      errors.password_confirmation = "Password confirmation is too short";

    return errors;
  };

  const navigate = useNavigate();

  // console.log(formData, "formData")

  // Function to handle form input changes
  const handleInputChange = (event) => {
    // console.log(event)
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    setOtpVerification({ ...otpVerification, [name]: value });

    // formData changes
    if (name === "email") {
      setChangedPassword({ ...changedPassword, [name]: value });
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const handleInputOtp = (value) => {
    setOtpValue(value);
    setOtpVerification({ ...otpVerification, otp: value });
  };
  const handlePasswordChange = (event) => {
    // console.log(event)
    const { name, value } = event.target;
    // setChangedPassword({ ...changedPassword, [name]: value });
    setChangedPassword({
      ...changedPassword,
      [name]: value,
      email: formData.email,
    });

    if (name === "password_confirmation") {
      setPasswordMatchError(
        value !== formData.password ? "Passwords do not match" : ""
      );
    }

    if (name === "password") {
      validatePassword(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("testing logic");
    const formErrors = validateValues(formData);
    setErrors(formErrors);

    // Check if there are any errors
    if (Object.keys(formErrors).length > 0) {
      // setErrors(formErrors);
      // There are validation errors, do not submit the form
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...formData,
      };
      const response = await postRequestGlobal("forgot/resetPassword", payload);

      // Assuming response has a status and message field
      if (response.status === false) {
        // setErrors({ email: response.message });
        setAlertMessage(response.message);
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }

      setShowForgetPasswordForm(false);
      setShowOtpForm(true); // Show the OTP form
      // setEmail(formData.email); // Set the email state

      if (formData.email) {
        setEmail(formData.email); // Set the email state
      } else {
        console.error("Email not found in formData");
      }
      //   const data = await response.json();
      // console.log("Response:", response);
      // Handle success or further actions here
      // alert('Otp has sent successfully!');
      // setAlertMessage('Otp has sent successfully!');
      setAlertMessage(response.message);
      setAlertSeverity("success");
      setAlertOpen(true);
    } catch (error) {
      console.error("Error: ", error);
      // Handle error or display error message
      // alert('Error submitting form. Please try again later.');
      // setErrors('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
  };

  const handleSubmitOtpVerification = async (e) => {
    e.preventDefault();
    // const formErrors = validateValues(formData);
    // Validate the OTP value
    if (!otpValue || otpValue.length !== 6) {
      // assuming OTP should be 6 digits long
      setErrors("Invalid OTP entered. Please enter a valid 6-digits OTP.");
      setAlertMessage(
        "Invalid OTP entered. Please enter a valid 6-digits OTP."
      );
      setAlertSeverity("error");
      setAlertOpen(true);
      return;
    }

    // Check if there are any errors
    // if (Object.keys(formErrors).length > 0) {

    //     return;
    // }
    setLoading(true);
    try {
      const payload = {
        ...otpVerification,
      };
      const response = await postRequestGlobal("forgot/verifyOtp", payload);
      // console.log(response)
      const checkstatus = response.status;
      if (checkstatus) {
        // adjust this check based on your API response structure
        setShowOtpForm(false); // Proceed to the next step only if OTP is verified
        setAlertMessage("Otp has successfully verified!");
        setAlertSeverity("success");
        setAlertOpen(true);
      } else {
        setErrors("Invalid OTP entered");
        // setAlertMessage('Invalid OTP entered');
        setAlertMessage(response.message);
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }

      // setShowOtpForm(0)
      // console.log("Response:", response);
      // setAlertMessage('Otp has successfully verified!');
      // setAlertSeverity('success');
      // setAlertOpen(true);
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      // setErrors('Invalid OTP entered');
      // setAlertMessage('Invalid OTP entered');
      // setAlertSeverity('error');
      setErrors({ otp: "Error submitting form. Please try again later." });
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
  };

  const handleSubmitChangedPassword = async (e) => {
    e.preventDefault();
    // console.log("testing")

    const formErrors = validatePasswordValues(changedPassword);

    // console.log(formErrors)
    setErrors(formErrors);

    // Check if there are any errors
    // if (Object.keys(formErrors).length > 0) {

    //      return;
    // }

    if (
      Object.keys(formErrors).length > 0 ||
      passwordError ||
      passwordMatchError
    ) {
      return;
    }

    // Perform form validation here
    if (changedPassword.password !== changedPassword.password_confirmation) {
      // alert('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...changedPassword,
      };
      const response = await postRequestGlobal(
        "forgot/changePassword",
        payload
      );
      // setChangedPassword(0)
      // if (response.ok) {
      //     alert('Password changed successfully!');
      //     navigate('/');
      // } else {
      //     // const data = await response.json();
      //     setErrors('Failed to reset password. Please try again.');
      // }

      // const data = await response.json();
      // console.log("Response:", response);
      // Handle success or further actions here, such as redirecting to another page
      setAlertMessage("Password changed successfully!");
      setAlertSeverity("success");
      setAlertOpen(true);

      // navigate('/');
      setTimeout(() => {
        navigate("/");
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error: ", error);
      setErrors("Failed to reset password. Please try again.");
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 800);
    }
  };

  return (
    <>
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          // bgcolor="#1c57687d"
          bgcolor="#1c682c7d"
          zIndex={1000}
        >
          <img src={pecock_vdo} alt="Loading..." />
        </Box>
      )}

      {
        showForgetPasswordForm ? (
          <ForgetPasswordDetails
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            errors={errors}
          />
        ) : showOtpForm ? (
          <VerifyOtpVerification
            otpValue={otpValue}
            handleInputOtp={handleInputOtp}
            handleSubmitOtpVerification={handleSubmitOtpVerification}
            setShowForgetPasswordForm={setShowForgetPasswordForm}
            email={email}
          />
        ) : (
          <ChangedPasswordDetails
            changedPassword={changedPassword}
            errors={errors}
            handlePasswordChange={handlePasswordChange}
            handleSubmitChangedPassword={handleSubmitChangedPassword}
          />
        )
        // <NewPassword/>
      }

      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ForgetPassword;
